import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {CourseFilter} from "../../../partials/CourseFilter";
import {useSearchCardsQuery} from "../../../../types.d";
import {config} from "config";

export default function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            return () => {
                clearTimeout(handler);
            };
        },
        [value]
    );

    return debouncedValue;
}

export const ContentEditingPage = (props) => {
    const [wordSearch, setWordSearch] = useState<string>('')
    const [contentSearch, setContentSearch] = useState<string>('')
    const [selectedCourse, setSelectedCourse] = useState<number>(null)

    const debouncedWord = useDebounce(wordSearch, 500)
    const debouncedContent = useDebounce(contentSearch, 500)

    console.log(debouncedContent)

    const search = useSearchCardsQuery({
        skip: !debouncedWord.length && !debouncedContent.length,
        variables: {
            content: debouncedContent || null,
            word: debouncedWord || null,
            courseId: selectedCourse
        }
    })

    const exercises = () => search.data.searchCards.filter(item => item.exerciseRules && item.exerciseRules.length);
    const vocabularies = () => search.data.searchCards.filter(item => item.wordRank);

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Global Content Editing
                    </li>
                </ol>
            </nav>

            <CourseFilter onChange={c => {
                setSelectedCourse(c ?? null)
            }} />
            <div className={'input-group mt-1'}>
                <input
                    value={wordSearch}
                    onChange={e => {
                        setWordSearch(e.currentTarget.value)
                        setContentSearch('')
                    }}
                    type={'text'}
                    className={'form-control'}
                    placeholder={'Word search...'} />
                <input
                    type={'text'}
                    value={contentSearch}
                    onChange={e => {
                        setContentSearch(e.currentTarget.value)
                        setWordSearch('')
                    }}
                    className={'form-control'}
                    placeholder={'Content search...'} />
            </div>

            { search.data && vocabularies().length > 0 && (
                <table className={'table mt-3'}>
                    <thead className="thead-dark">
                    <tr>
                        <th>Vocabulary</th>
                        <th>Translation</th>
                        <th>Position</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                        { vocabularies().map(item => {
                            return (
                                <tr>
                                    <td>{ item.sourceLemma }</td>
                                    <td>{ item.translationLemma }</td>
                                    <td>{ item.wordRank }</td>
                                    <td><a target={'_blank'} href={`/edit/translation/?translation_id=${item.translationId}&card_id=${item.id}&content_editing=true`}>edit translation</a></td>
                                    <td><a target={'_blank'} href={`/edit/vocabulary/?card_id=${item.id}&content_editing=true`}>edit content</a></td>
                                    <td><a target={'_blank'} href={`${config.frontendBase}/course?previewCardId=${item.id}`}>preview</a></td>
                                </tr>
                            );
                        }) }
                    </tbody>
                </table>
            ) }

            { search.data && exercises().length > 0 && (
                <table className={'table mt-3'}>
                    <thead className="thead-dark">
                    <tr>
                        <th>Topic name</th>
                        <th>Explanation card</th>
                        <th>Exercise card</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    { exercises().map(item => {
                        return (
                            <tr>
                                <td>{ item.topicTitle }</td>
                                <td>{ item.explanationTitle }</td>
                                <td>{ item.exerciseTitle }</td>
                                <td><a target={'_blank'} href={`/edit/exercise/?card_id=${item.id}&content_editing=true`}>edit</a></td>
                                <td><a target={'_blank'} href={`${config.frontendBase}/course?previewCardId=${item.id}`}>preview</a></td>
                            </tr>
                        );
                    }) }
                    </tbody>
                </table>
            ) }
        </div>
    </div>
}
